import TablaConciliacion from "../../../TablaConciliacion";

function TablaSisga() {
  return <TablaConciliacion nombreUseCase="SISGA" titulo="SISGA" />;
}

export default TablaSisga;
